import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { DiscardConfirmationExceptionHandlingComponent } from "../discard-confirmation-exception-handling/discard-confirmation-exception-handling.component";
import { Component, ViewChild } from "@angular/core";
import { TableModule } from "primeng/table";
import { FilingRecords } from "../../../../api/models/filing-records";
import { Button } from "primeng/button";
import { Tooltip } from "primeng/tooltip";
import { Dialog } from "primeng/dialog";
import { FilingRecordsService } from "../../../../api/services/filing-records.service";
import { MessageService, SelectItem } from "primeng/api";
import { Toast } from "primeng/toast";
import { FormsModule } from "@angular/forms";
import { FloatLabel } from "primeng/floatlabel";
import { Textarea } from "primeng/textarea";
import { DropdownModule } from "primeng/dropdown";
import { CommonModule, NgIf } from "@angular/common";
import { FormType } from "../../../../api/models/form-type";
import { FormFilterForException } from "../../../../api/models/form-filter-for-exception";
import { MultiDiscard } from "src/api/models";
import { DatePicker } from "primeng/datepicker";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
@Component({
  selector: "app-update-extraction",
  imports: [
    CommonModule,
    TableModule,
    Button,
    Tooltip,
    Dialog,
    Toast,
    FormsModule,
    FloatLabel,
    Textarea,
    DropdownModule,
    NgIf,
    DatePicker,
  ],
  templateUrl: "./update-extraction.component.html",
  styleUrl: "./update-extraction.component.css",
})
export class UpdateExtractionComponent {
  isSaveLoading: boolean = false;
  first = 0;
  isLoading: boolean = false;
  rows = 10;
  selectedFiling: any[] = [];
  showValidationError = false;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  maxCharToShow = "Other Information: None".length;
  filingRecords = [] as FilingRecords[];
  isDialogVisible = false;
  selectedFilingRecord = {} as FilingRecords;
  isReportDialogVisible = false;
  ref!: DynamicDialogRef;
  selectedIssueType = "";
  issueTypes = ["Pattern Issue", "Bot Malfunctioning"].map((t) => {
    return { label: t, value: t } as SelectItem;
  });
  filingIdInput?: number;
  issuerNameInput?: string;
  formTypes = FormType.values();
  selectedFormType: FormType | null = null;
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  constructor(
    private filingRecordsService: FilingRecordsService,
    private _messageService: MessageService,
    public dialogService: DialogService
  ) {}

  showModal(filingRecord: any) {
    this.selectedFilingRecord = filingRecord;
    this.isDialogVisible = true;
  }

  saveTheText() {
    this.showValidationError = false;

    if (!this.selectedIssueType || this.selectedIssueType.trim() === "") {
      this.showValidationError = true;
      return;
    }

    this.isSaveLoading = true;
    this.selectedFilingRecord.issueType = this.selectedIssueType;
    const param = this.selectedFilingRecord;
    this.filingRecordsService.saveFilingRecord(param).subscribe({
      next: (value) => {
        if (value)
          this._messageService.add({
            summary: "Text is saved successfully",
            key: "message",
            severity: "success",
          });
      },
      error: (err) => {
        this.isSaveLoading = false;
        this._messageService.add({
          summary: "Something went wrong",
          key: "message",
          severity: "error",
        });
      },
      complete: () => {
        this.isSaveLoading = false;
        this.isDialogVisible = false;
        this.isReportDialogVisible = true;
        this.selectedIssueType = "";
        this.loadData({ first: this.first, rows: this.rows });
      },
    });
  }
  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.fetchRecords();
  }
  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)

      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);

      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }
  onSearch() {
       const fid = String(this.filingIdInput ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.fetchRecords();
  }
    preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  private fetchRecords() {
    const params: FormFilterForException = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      issuerName: this.issuerNameInput,
      formType: this.selectedFormType as any,
      filingId: this.filingIdInput,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this.filingRecordsService.getFilingRecords(params).subscribe({
      next: (value) => {
        if (value) this.filingRecords = value;
      },
      error: (err) => {
        this._messageService.add({
          key: "message",
          data: err,
          summary: "Something went wrong",
          severity: "error",
        });
        this.isLoading = false;
      },
      complete: () => {
        this.paginator.totalCount =
          this.filingRecords.length > 0 ? this.filingRecords[0].totalCount! : 0;

        this.isLoading = false;
      },
    });
  }

  discardFiling(filing: any): void {
    // this.ref = this.dialogService.open(
    //   DiscardConfirmationExceptionHandlingComponent,
    //   {
    //     width: "30vw",
    //     data: { filing },
    //     dismissableMask: false,
    //     closable: true,
    //     modal: true,
    //   }
    // );
    //
    // this.ref.onClose.subscribe((data) => {
    //   if (data?.reason) {
    this.isLoading = true;
    this.filingRecordsService
      .discardFilingRecord({
        recordId: filing.recordId,
        reason: "no plan found",
      })
      .subscribe({
        next: () => {
          this._messageService.add({
            severity: "success",
            summary: "Discarded",
            detail: `FilingRecordId #${filing.recordId} discarded successfully.`,
            key: "message",
          });
          this.fetchRecords();
        },
        error: (err) => {
          this._messageService.add({
            severity: "error",
            summary: "Error",
            detail: err?.error?.message || "Failed to discard filing.",
          });
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false; // 🔹 reset always
        },
      });
    //   }
    // });
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  onGroupDiscardClick() {
    const discardIds = this.selectedFiling
      .filter((filing) => filing.recordId !== undefined)
      .map((filing) => filing.recordId);
    const submission: MultiDiscard = {
      ids: discardIds,
      reason: "no plan found",
    };

    this.isLoading = true;
    this.filingRecordsService.multiDiscardFilingRecord(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been discarded successfully.",
        });
        this.selectedFiling = [];
        this.fetchRecords();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false; // 🔹 reset always
      },
    });
  }
  shouldDisableRowAction(record: any): boolean {
    // Add your logic here, e.g., disable if it's in selectedFiling
    return this.selectedFiling.includes(record);
  }
}
